export enum DeviceTypes {
	MOBILE = 'mobile',
	TAB = 'tab',
	DESKTOP = 'desktop',
}

export enum PlatFormTypes {
	IOS = 'ios',
	ANDROID = 'android',
	MWEB = 'm-web',
	DESKTOP = 'desktop',
}

export enum ViewTypes {
	LANDING = 'landing',
	LOGIN = 'login',
	OTP = 'otp',
	USER_INFO = 'user_info',
	VOTES = 'votes',
	OFFERS = 'offers',
	TNC = 'tnc',
	WINNERS = 'winners',
	SCRATCH = 'scratch',
}

export enum UserInfoType {
	REGINAL_LANGUAGE_PROFICIENCY = 'regionalLanguageProficiency',
	NAME = 'name',
	EMAIL = 'email',
	DOB = 'dob',
	GENDER = 'gender',
	EDUCATION = 'education',
	STATE = 'state',
	CITY = 'city',
}

export interface MetaType {
	isLogin: boolean
	deviceType: DeviceTypes
	platform: PlatFormTypes
	view: ViewTypes
	isLoading: boolean
	isError: boolean
	errorMessage: string | ''
	votingClose: boolean
	userInfoStep: UserInfoType
	nextRouteParams: string
}
